var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 44,
    viewBox: "0 0 75 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dark_new",
    "data-name": "Dark new",
    transform: "translate(-4094 -10874)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2756",
    "data-name": "Rectangle 2756",
    width: 75,
    height: 44,
    rx: 2,
    transform: "translate(4094 10874)",
    fill: "#11141d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2757",
    "data-name": "Rectangle 2757",
    width: 11,
    height: 3,
    rx: 0.5,
    transform: "translate(4142 10901)",
    fill: "#00db6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2758",
    "data-name": "Rectangle 2758",
    width: 11,
    height: 3,
    rx: 0.5,
    transform: "translate(4155 10901)",
    fill: "#ff4033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2759",
    "data-name": "Rectangle 2759",
    d: "M2,0H73a2,2,0,0,1,2,2V4a0,0,0,0,1,0,0H0A0,0,0,0,1,0,4V2A2,2,0,0,1,2,0Z",
    transform: "translate(4094 10874)",
    fill: "#363841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2760",
    "data-name": "Rectangle 2760",
    width: 24,
    height: 2,
    rx: 0.5,
    transform: "translate(4142 10881)",
    fill: "#363841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2761",
    "data-name": "Rectangle 2761",
    width: 24,
    height: 2,
    rx: 0.5,
    transform: "translate(4142 10885)",
    fill: "#363841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2762",
    "data-name": "Rectangle 2762",
    width: 24,
    height: 2,
    rx: 0.5,
    transform: "translate(4142 10889)",
    fill: "#363841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2763",
    "data-name": "Rectangle 2763",
    width: 24,
    height: 2,
    rx: 0.5,
    transform: "translate(4142 10893)",
    fill: "#363841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2764",
    "data-name": "Rectangle 2764",
    width: 24,
    height: 2,
    rx: 0.5,
    transform: "translate(4142 10897)",
    fill: "#363841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2765",
    "data-name": "Rectangle 2765",
    width: 43,
    height: 8,
    rx: 1,
    transform: "translate(4097 10906)",
    fill: "#363841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2766",
    "data-name": "Rectangle 2766",
    width: 24,
    height: 8,
    rx: 1,
    transform: "translate(4142 10906)",
    fill: "#363841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2767",
    "data-name": "Rectangle 2767",
    width: 43,
    height: 23,
    rx: 1,
    transform: "translate(4097 10881)",
    fill: "#363841"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkNew);
export default __webpack_public_path__ + "static/media/Dark-new.59fe47946b3179702367b0e768450400.svg";
export { ForwardRef as ReactComponent };